import _classCallCheck from "C:\\vstsagent\\multiCribis-build-agent\\_work\\58\\s\\Source\\Crif.BlueBabylon.Web\\ClientApp\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\vstsagent\\multiCribis-build-agent\\_work\\58\\s\\Source\\Crif.BlueBabylon.Web\\ClientApp\\node_modules\\@babel\\runtime/helpers/esm/createClass";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Not exported from index
/** @private */
export var TextMessageFormat = /*#__PURE__*/function () {
  function TextMessageFormat() {
    _classCallCheck(this, TextMessageFormat);
  }
  _createClass(TextMessageFormat, null, [{
    key: "write",
    value: function write(output) {
      return "".concat(output).concat(TextMessageFormat.RecordSeparator);
    }
  }, {
    key: "parse",
    value: function parse(input) {
      if (input[input.length - 1] !== TextMessageFormat.RecordSeparator) {
        throw new Error("Message is incomplete.");
      }
      var messages = input.split(TextMessageFormat.RecordSeparator);
      messages.pop();
      return messages;
    }
  }]);
  return TextMessageFormat;
}();
TextMessageFormat.RecordSeparatorCode = 0x1e;
TextMessageFormat.RecordSeparator = String.fromCharCode(TextMessageFormat.RecordSeparatorCode);